import { __decorate } from "tslib";
import screenfull from 'screenfull';
import { Component, Vue } from 'vue-property-decorator';
const sf = screenfull;
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isFullscreen = false;
  }
  mounted() {
    if (sf.isEnabled) {
      sf.on('change', this.change);
    }
  }
  beforeDestory() {
    if (sf.isEnabled) {
      sf.off('change', this.change);
    }
  }
  change() {
    if (sf.isEnabled) {
      this.isFullscreen = sf.isFullscreen;
    }
  }
  click() {
    if (!sf.isEnabled) {
      this.$message({
        message: 'you browser can not work',
        type: 'warning'
      });
      return false;
    }
    sf.toggle();
  }
};
default_1 = __decorate([Component({
  name: 'Screenfull'
})], default_1);
export default default_1;